import React from 'react';
import {HeaderWidget} from './widget/header/header_widget';
import {HashRouter as Router, Switch, Route, Redirect,} from "react-router-dom";
import {WidthStyle} from "./widget/style/width_style";
import styled, {ThemeProvider} from "styled-components";
import {PersonalPage} from "./view/personal";
import {ClaimsPage} from "./view/claims";
import {useWallet, UseWalletProvider} from 'use-wallet'
import {AppConfig} from "./config";
import {ModelProvider} from "./provider/model_provider";
import {BackdropProvider} from "./provider/backdrop_provider";
import {WalletConnect} from "./model/wallet_connect";
import {Web3Provider} from "./provider/web3_provider";
import {theme, themes} from "./theme";
import {MuiThemeProvider} from "@material-ui/core";
import {AdminPage} from "./view/admin";
import {MsgPage} from "./view/challenge/arbitration";
import {ArbitrationPage} from "./view/claims/arbitration/arbitration";

function App() {
    return (
        <UseWalletProvider chainId={parseInt(AppConfig.chainId)} connectors={{
            walletconnect: {rpcUrl: AppConfig.rpcUrl[AppConfig.chainId]}
        }}>
            <ThemeProvider theme={theme}>
                <MuiThemeProvider theme={themes}>
                    <Web3Provider>
                        <ModelProvider>
                            <BackdropProvider>
                                <div className="App">
                                    <Page/>
                                </div>
                            </BackdropProvider>
                        </ModelProvider>

                    </Web3Provider>
                </MuiThemeProvider>

            </ThemeProvider>


        </UseWalletProvider>
    );
}


const Page: React.FC = () => {
    const {status} = useWallet();

    return (
        <>
            {
                status === 'connected' ? <Router> <HeaderWidget/><MainStyle>
                        <Switch>
                            <Route path="/:type/msgpage/:id" component={MsgPage} />
                            <Route path="/:type/arbitration/:id" component={ArbitrationPage} />
                            <Route path="/personal/" component={PersonalPage}/>
                            <Route path="/admin/" component={AdminPage}/>
                            <Route path="/claims/" component={ClaimsPage}/>
                            <Redirect to="/personal/"/>
                        </Switch>
                    </MainStyle></Router> :
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'center',
                            height: '100vh'
                        }}
                    >
                        <WalletConnect />
                    </div>

            }
        </>
    )
}


const MainStyle = styled.div`
  ${WidthStyle.MaxWidth};
`;

export default App;

